export const TranslationKey = {
   PAYCORCULTURE : "paycorCulture",
    ENGLISH : "en",
    FRENCH : "fr",
    SPANISH : "es"
 }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/shared/TranslationConstants.ts